/*! StartNoStringValidationRegion - session types */
export enum SessionType {
  General = "general",
  Mobility = "mobility",
}
/*! EndNoStringValidationRegion */
